module.exports = __webpack_public_path__ + "media/beer.30e9b3d7.mp3";